<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="请选择机构" prop="organizationId" >
        <a-select v-model="form.organizationId" placeholder="请选择机构" allow-clear>
          <a-select-option v-for="item in organizationList" :key="item.id">
            {{ item.name }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="请选择教师" prop="teacherId" >
        <a-select v-model="form.teacherId" placeholder="请选择教师" allow-clear>
          <a-select-option v-for="item in teacherList" :key="item.id">
            {{ item.name }}
          </a-select-option>
        </a-select>

      </a-form-model-item>
      <a-form-model-item label="课程名称" prop="name" >
        <a-input v-model="form.name" placeholder="请输入课程名称" />
      </a-form-model-item>
      <a-form-model-item label="课程视频" prop="video" >
        <file-upload
          :key="'open-course-video-' + (form.id != null ? form.id : 'new')"
          type="file"
          :defaultList="form.videoArr"
          :count="form.videoCount"
          @input="getImg($event, 'video')"
        />
        <video
          v-if="form.video && form.videoArr && form.videoArr.length"
          style="width: 180px; height: 120px"
          class="avatar video-avatar"
          controls="controls"
          :src="form.videoArr[0].url"
        />
      </a-form-model-item>
      <a-form-model-item label="课程介绍" prop="content" >
        <editor v-if="open" v-model="form.content" :key="'open-course-content-' + (form.id != null ? form.id : 'new')" />
      </a-form-model-item>
      <a-form-model-item label="备注" prop="remark" >
        <a-input v-model="form.remark" placeholder="请输入内容" type="textarea" allow-clear />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getOpenCourse, addOpenCourse, updateOpenCourse } from '@/api/openCourse/openCourse'
import Editor from '@/components/Editor'
import {listOrganization} from "@/api/organization/organization";
import {listTeacher} from "@/api/teacher/teacher";
import {guid} from "@/api/utils/ruoyi";

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    Editor
  },
  data () {
    return {
      submitLoading: false,
      organizationList: [],
      teacherList: [],
      formTitle: '',
      // 表单参数
      form: {
        id: null,

        organizationId: null,

        teacherId: null,

        name: null,

        video: null,
        videoArr: [],
        videoCount: 1,

        content: null,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        organizationId: [
          { required: true, message: '机构不能为空', trigger: 'blur' }
        ],
        // teacherId: [
        //   { required: true, message: '教师id,外键{zb_teacher.id}不能为空', trigger: 'blur' }
        // ],
        name: [
          { required: true, message: '课程名称不能为空', trigger: 'blur' }
        ],
        video: [
          { required: true, message: '课程视频不能为空', trigger: 'blur' }
        ],
        content: [
          { required: true, message: '课程介绍不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        organizationId: null,
        teacherId: null,
        name: null,
        video: null,
        videoArr: [],
        videoCount: 1,
        content: null,
        createTime: null,
        remark: null,
      }
      this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })
    },
    /** 获取机构列表 */
    getOrganizationList () {
      listOrganization().then(response => {
        this.organizationList = response.data
      })
    },
    /** 获取教师列表 */
    getTeacherList () {
      listTeacher({organizationId: this.form.organizationId}).then(response => {
        this.teacherList = response.data
      })
    },
    /******************** 上传图片数据处理 start ********************/
    /**前端 需要将图片格式处理成数组，方便数据回显 */
    setImgData(field, img) {
      let fieldImgArr = []
      if (!img || typeof img !== 'string') {
        return fieldImgArr
      }
      if (img.indexOf(",") === -1) {
        if (this.form[`${field}Count`] === 1) {
          if (img) {
            fieldImgArr.push({
              uid: guid(8, 10),
              name: img,
              status: 'done',
              halfUrl: img,
              url: img,
              path: img
            })
          }
        }
      } else {
        // 多图
        if (this.form[`${field}Count`] > 1) {
          let imgArr = img.split(",")
          console.log("多图", imgArr)
          if (imgArr.length) {
            console.log("来过了", imgArr)
            imgArr.map(item => {
              fieldImgArr.push({
                uid: guid(8, 10),
                name: img,
                status: 'done',
                halfUrl: img,
                url: item,
                path: item
              })
            })
          }
        }
      }
      return fieldImgArr
    },
    /**上传图片成功回调 */
    getImg(info, fieldName) {
      console.log('info', info)
      if (info.length === 0) {
        this.form[fieldName] = ''
        this.form[`${fieldName}Arr`] = []
      } else {
        if (this.form[`${fieldName}Count`] === 1) {
          this.form[fieldName] = info[0].url
          this.form[`${fieldName}Arr`] = info
        } else {
          this.form[fieldName] = info.map(ele => { return ele.url }).join(",")
          this.form[`${fieldName}Arr`] = info
        }
      }
    },
    /** 点击视频 弹窗打窗口播放视频*/
    async handlePreview(file) {
      this.previewImage = this.form.video || file.video;
      this.previewVisible = true;
      this.$nextTick(() => {
        this.$refs.myVideo.play()
      })
    },
    handleCancel() {
      this.previewVisible = false;
    },
    /******************** 上传图片数据处理 end   ********************/
    /** 新增按钮操作 */
    handleAdd (row) {
      this.getOrganizationList()
      this.getTeacherList()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
      this.reset()
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.getOrganizationList()
      this.formType = 2
      const rawId = row != null && row.id != null ? row.id : ids
      const id = Array.isArray(rawId) ? rawId[0] : rawId
      if (id == null || id === '') {
        this.$message.warning('未获取到记录编号')
        return
      }
      getOpenCourse({ id }).then(response => {
        const data = response && response.data != null ? response.data : {}
        this.form = Object.assign({}, this.form, data, {
          videoCount: 1,
          videoArr: []
        })
        if (this.form.video) {
          this.form.videoArr = this.setImgData('video', this.form.video)
        }
        this.open = true
        this.formTitle = '修改'
        this.$nextTick(() => {
          this.getTeacherList()
          if (this.$refs.form) {
            this.$refs.form.clearValidate()
          }
        })
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateOpenCourse(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addOpenCourse(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
